var map = {
	"./3rd-party-logos/meitav.svg": 16486,
	"./Share button.svg": 85281,
	"./Vector.svg": 65923,
	"./alert_icon.svg": 8888,
	"./ambassadors/ambassador-page-header.svg": 75450,
	"./ambassadors/ambassadors-header-color.svg": 57605,
	"./ambassadors/ambassadors-page-header-150-benefit.svg": 26758,
	"./ambassadors/ambassadors-page-header-50-percent-benefit.svg": 91399,
	"./ambassadors/ambassadors-page-header.svg": 13089,
	"./ambassadors/ambassadors-popup-header.svg": 18160,
	"./ambassadors/competition-card-background.svg": 30044,
	"./ambassadors/hever-header.svg": 87913,
	"./ambassadors/step-1.svg": 20075,
	"./ambassadors/step-2.svg": 62008,
	"./ambassadors/step-3.svg": 87369,
	"./ambassadors/step1.svg": 95618,
	"./ambassadors/step2.svg": 52721,
	"./ambassadors/step3.svg": 38336,
	"./arrow-left-vector.svg": 41659,
	"./bank-connection-failure.png": 32524,
	"./bank-connection-success.png": 37519,
	"./bank-logos-30/CCAMX45.png": 63293,
	"./bank-logos-30/CCCal45.png": 44947,
	"./bank-logos-30/CCIsracard45.png": 9272,
	"./bank-logos-30/CCLeumi45.png": 74543,
	"./bank-logos-30/Yahav45.png": 48918,
	"./bank-logos-30/amex-large.svg": 17271,
	"./bank-logos-30/budgetz-long.svg": 15386,
	"./bank-logos-30/budgetz.svg": 71975,
	"./bank-logos-30/cal-diners.svg": 19278,
	"./bank-logos-30/discount.svg": 88365,
	"./bank-logos-30/doar.svg": 89510,
	"./bank-logos-30/egud.svg": 86623,
	"./bank-logos-30/habeinleumi.svg": 58045,
	"./bank-logos-30/hapoalim.svg": 94355,
	"./bank-logos-30/isracard-logo.png": 19459,
	"./bank-logos-30/leumi.svg": 6400,
	"./bank-logos-30/leumicard-max.png": 3771,
	"./bank-logos-30/massad.svg": 25787,
	"./bank-logos-30/mercantile.png": 22128,
	"./bank-logos-30/mizrachi.svg": 21091,
	"./bank-logos-30/otsar.png": 70977,
	"./bank-logos-30/pagi.png": 60311,
	"./bank-logos-30/pepper-large.svg": 91814,
	"./bank-logos-30/ubank.png": 20431,
	"./bank-logos-45/BankPoalim45.png": 93579,
	"./bank-logos-45/CCAMX45.png": 83897,
	"./bank-logos-45/CCCal45.png": 95871,
	"./bank-logos-45/CCIsracard45.png": 24252,
	"./bank-logos-45/CCLeumi45.png": 65555,
	"./bank-logos-45/Discount45.png": 45170,
	"./bank-logos-45/Doar45.png": 60977,
	"./bank-logos-45/Egood45.png": 23015,
	"./bank-logos-45/Habenleumi45.png": 73079,
	"./bank-logos-45/Hayal45.png": 60180,
	"./bank-logos-45/Jerusalem45.png": 72447,
	"./bank-logos-45/Leumi45.png": 20105,
	"./bank-logos-45/Masad45.png": 80207,
	"./bank-logos-45/Mercantil45.png": 43148,
	"./bank-logos-45/Mizrahi45.png": 60175,
	"./bank-logos-45/Pegi45.png": 48750,
	"./bank-logos-45/Pepper45.png": 3055,
	"./bank-logos-45/UBank45.png": 43538,
	"./bank-logos-45/Yahav45.png": 85186,
	"./bank-logos/amex-large.svg": 96109,
	"./bank-logos/amex-stacked.png": 41267,
	"./bank-logos/amex-stacked.svg": 51971,
	"./bank-logos/amex.jpg": 94379,
	"./bank-logos/blue-redirect-info-icon.svg": 41750,
	"./bank-logos/budgetz-long.svg": 51008,
	"./bank-logos/budgetz.svg": 89709,
	"./bank-logos/cal-diners-stacked.png": 46328,
	"./bank-logos/cal-diners-stacked.svg": 88020,
	"./bank-logos/cal-diners.svg": 32628,
	"./bank-logos/cal-stacked.png": 62908,
	"./bank-logos/cal.jpg": 32820,
	"./bank-logos/discount-large.svg": 87233,
	"./bank-logos/discount-small.svg": 47961,
	"./bank-logos/discount.jpg": 8963,
	"./bank-logos/doar-large.svg": 10802,
	"./bank-logos/doar-small.svg": 91574,
	"./bank-logos/doar.jpg": 41412,
	"./bank-logos/egud.jpg": 46525,
	"./bank-logos/habeinleumi-large.svg": 78989,
	"./bank-logos/habeinleumi-small.svg": 73941,
	"./bank-logos/habenleumi.jpg": 95522,
	"./bank-logos/hapoalim-large.svg": 24035,
	"./bank-logos/hapoalim-small.svg": 90119,
	"./bank-logos/igud-large.svg": 859,
	"./bank-logos/igud-small.svg": 42879,
	"./bank-logos/isracard-large.svg": 64413,
	"./bank-logos/isracard-logo.png": 66975,
	"./bank-logos/isracard-stacked.svg": 7347,
	"./bank-logos/isracard.jpg": 77671,
	"./bank-logos/jerusalem-large.jpg": 50060,
	"./bank-logos/jerusalem.jpg": 43834,
	"./bank-logos/leumi-large.svg": 80424,
	"./bank-logos/leumi-obk-small.svg": 4697,
	"./bank-logos/leumi-small.svg": 95056,
	"./bank-logos/leumi.jpg": 33356,
	"./bank-logos/leumicard-max-stacked.png": 3567,
	"./bank-logos/leumicard-max.png": 59375,
	"./bank-logos/leumicard-stacked.png": 30962,
	"./bank-logos/leumicard.jpg": 53278,
	"./bank-logos/masad.jpg": 8682,
	"./bank-logos/massad-large.svg": 33319,
	"./bank-logos/massad-small.svg": 25995,
	"./bank-logos/max-leumi-stacked.svg": 99503,
	"./bank-logos/meitav.svg": 92398,
	"./bank-logos/mercantil.jpg": 11213,
	"./bank-logos/mercantile-large.png": 68718,
	"./bank-logos/mercantile-small@3x.jpg": 47537,
	"./bank-logos/mizrachi-large.svg": 14219,
	"./bank-logos/mizrachi-small.svg": 72559,
	"./bank-logos/mizrahi.jpg": 31210,
	"./bank-logos/one-zero.png": 4725,
	"./bank-logos/otsar-large.jpg": 40255,
	"./bank-logos/otsar-large.png": 45295,
	"./bank-logos/otzarhahayal.jpg": 24392,
	"./bank-logos/pagi-large.png": 84269,
	"./bank-logos/pagi.jpg": 57243,
	"./bank-logos/pepper-badge-large.svg": 56954,
	"./bank-logos/pepper-large.svg": 38632,
	"./bank-logos/pepper-redirect-info-icon.svg": 99542,
	"./bank-logos/pepper.png": 43854,
	"./bank-logos/poalim.jpg": 23748,
	"./bank-logos/ubank-large.png": 25013,
	"./bank-logos/ubank.jpg": 16355,
	"./bank-logos/yahav-large.jpg": 99221,
	"./bank-logos/yahav-new-large.png": 6512,
	"./bank-logos/yahav.jpg": 76467,
	"./banners/agam-banner.svg": 48703,
	"./banners/blue-shapes-with-logo.svg": 36862,
	"./banners/shekel-banner.svg": 61199,
	"./black-and-white-pot.png": 32153,
	"./black-and-white-snapping-finger.png": 62234,
	"./blue-flower-card.svg": 78393,
	"./blue-pencil.svg": 96764,
	"./blue-x.svg": 4605,
	"./bot.png": 59093,
	"./botprofile@3x.jpg": 57953,
	"./cards/amex.png": 73057,
	"./cards/cal.png": 9070,
	"./cards/diners_visacal.png": 85755,
	"./cards/isracard.png": 35453,
	"./cards/leumicard.png": 5892,
	"./cashflow-start-day-walkthrough/1 to 9/cashflow-after-change.svg": 80510,
	"./cashflow-start-day-walkthrough/1 to 9/current-cashflow.svg": 38256,
	"./cashflow-start-day-walkthrough/1 to 9/expenses.svg": 90626,
	"./cashflow-start-day-walkthrough/1 to 9/incomes-1.svg": 94029,
	"./cashflow-start-day-walkthrough/1 to 9/incomes-2.svg": 45678,
	"./cashflow-start-day-walkthrough/1 to 9/indent-explanation.svg": 85725,
	"./cashflow-start-day-walkthrough/10 to end of month/cashflow-after-change.svg": 54645,
	"./cashflow-start-day-walkthrough/10 to end of month/current-cashflow.svg": 94421,
	"./cashflow-start-day-walkthrough/10 to end of month/expenses.svg": 87303,
	"./cashflow-start-day-walkthrough/10 to end of month/incomes-1.svg": 7286,
	"./cashflow-start-day-walkthrough/10 to end of month/incomes-2.svg": 79157,
	"./cashflow-start-day-walkthrough/10 to end of month/indent-explanation.svg": 58460,
	"./cashflow-start-day-walkthrough/calendar-cashflow/1 to 9-cashflow-after-change.svg": 64661,
	"./cashflow-start-day-walkthrough/calendar-cashflow/1 to 9-incomes-and-expenses.svg": 74158,
	"./cashflow-start-day-walkthrough/calendar-cashflow/10 to end of month-cashflow-after-change.svg": 92814,
	"./cashflow-start-day-walkthrough/calendar-cashflow/10 to end of month-incomes-and-expenses.svg": 21591,
	"./cashflow-start-day-walkthrough/calendar-cashflow/current-cashflow.svg": 61235,
	"./cashflow-start-day-walkthrough/calendar.svg": 29153,
	"./cc-example.svg": 74589,
	"./celebrating-hands-drawing.png": 65476,
	"./challenge/Ellipse.svg": 6262,
	"./challenge/RoundBottom.svg": 12349,
	"./challenge/RoundBottomWhite.svg": 28216,
	"./challenge/active-challenge.svg": 97678,
	"./challenge/active-monthly-goal.svg": 46362,
	"./challenge/blue-v.svg": 19289,
	"./challenge/blue-x.svg": 38895,
	"./challenge/burger.svg": 40619,
	"./challenge/burrito.svg": 81719,
	"./challenge/croissant.svg": 25844,
	"./challenge/donut.svg": 84688,
	"./challenge/fries.svg": 57877,
	"./challenge/green-v.svg": 47360,
	"./challenge/heart-icon.svg": 21690,
	"./challenge/iceCream.svg": 82565,
	"./challenge/loties/Challenge-confeti": 20468,
	"./challenge/loties/Challenge-confeti.json": 20468,
	"./challenge/loties/Conffetti 02": 6650,
	"./challenge/loties/Conffetti 02.json": 6650,
	"./challenge/loties/Fail-ripple": 58131,
	"./challenge/loties/Fail-ripple.json": 58131,
	"./challenge/loties/Succsess-ripple": 20499,
	"./challenge/loties/Succsess-ripple.json": 20499,
	"./challenge/pitta.svg": 91766,
	"./challenge/pizza.svg": 19318,
	"./challenge/pretzel.svg": 66950,
	"./challenge/red-x.svg": 89042,
	"./challenge/riseup-badge.svg": 51230,
	"./challenge/sandwich.svg": 72887,
	"./challenge/takeout.svg": 85411,
	"./chat-bot/arrow_back.svg": 71580,
	"./chat-bot/black-hollow-double-star.svg": 53363,
	"./chat-bot/pink-double-star.svg": 96904,
	"./chat-bot/white-hollow-double-star.svg": 80657,
	"./check-green-happy.svg": 95601,
	"./check-with-green-circle.svg": 83050,
	"./checkbox-blue-marked.svg": 73591,
	"./churn/churn-icon.svg": 3583,
	"./churn/should-refund-icon.png": 31219,
	"./close-toaster.svg": 50225,
	"./close_icon.svg": 35822,
	"./coin-pile-drawing.png": 46659,
	"./comments.svg": 57220,
	"./crown.png": 61743,
	"./cx-avatars/guy-avatar@3x.png": 93071,
	"./cx-avatars/nofar-avatar@3x.png": 18394,
	"./cx-avatars/yael-avatar@3x.png": 67755,
	"./daily-routine-done.svg": 73847,
	"./daily-routine-settings.svg": 26588,
	"./demo/group.png": 50793,
	"./demo/one_number.png": 36578,
	"./demo/prev_months.png": 68787,
	"./demo/slide-1-image@3x.jpg": 75160,
	"./demo/slide-2-image@3x.jpg": 65949,
	"./demo/slide-3-image@3x.jpg": 70126,
	"./demo/slide-4-image@3x.jpg": 18811,
	"./demo/transactions.png": 47857,
	"./discount-riseup-friends.svg": 40584,
	"./dormant-locked.svg": 87128,
	"./dormant/short-term-dormant-default.png": 44159,
	"./dormant/short-term-dormant-months-free.png": 30416,
	"./dormant/short-term-dormant-percentage.png": 42274,
	"./down-full-arrow.svg": 87272,
	"./dynamic-deposit/authenticated-shapes.svg": 60251,
	"./dynamic-deposit/celebrate": 63491,
	"./dynamic-deposit/celebrate-share.png": 45248,
	"./dynamic-deposit/celebrate-share.svg": 27720,
	"./dynamic-deposit/celebrate.json": 63491,
	"./dynamic-deposit/error-page.svg": 52653,
	"./dynamic-deposit/non-authenticated-shapes.svg": 27413,
	"./dynamic-deposit/progress-bar/authentication.svg": 83125,
	"./dynamic-deposit/progress-bar/choose-amount.svg": 22631,
	"./dynamic-deposit/progress-bar/detailes.svg": 52830,
	"./dynamic-deposit/progress-bar/signature.svg": 35557,
	"./dynamic-deposit/shapes.svg": 40461,
	"./end-of-year/eoy-popup.svg": 69896,
	"./end-of-year/eoy.png": 28661,
	"./end-of-year/eoy.svg": 997,
	"./end-of-year/flower.svg": 56745,
	"./end-of-year/gift.svg": 61598,
	"./end-of-year/tooltip.png": 89685,
	"./error_icon.svg": 55116,
	"./errors/fallen-flower-pot.png": 64120,
	"./exceeding-variables-bar.svg": 9106,
	"./exclamation-mark@3x.png": 2482,
	"./fb-icon.svg": 66512,
	"./financial-success.png": 63477,
	"./generic-faliure.png": 76294,
	"./generic-success.png": 97759,
	"./goal-circle-disabled.svg": 36617,
	"./goal-circle.svg": 38900,
	"./great-success.png": 51131,
	"./grey-pencil.svg": 78271,
	"./group-7@3x.png": 62746,
	"./group-cx@3x.png": 95438,
	"./group@3x.jpg": 43966,
	"./half-round-header-background.svg": 55565,
	"./happy-star-drawing.png": 65730,
	"./heart.svg": 8354,
	"./help-outline@3x.png": 38091,
	"./hero-login.svg": 64166,
	"./hever/header_hever.svg": 23983,
	"./high-five-hands-drawing.png": 41055,
	"./how-much.png": 17904,
	"./icon-info.svg": 50,
	"./icon-lock.svg": 34507,
	"./icons/account_balance_24dp.svg": 3890,
	"./icons/add-disabled.svg": 95725,
	"./icons/add.svg": 71480,
	"./icons/ai-gradient-vector.svg": 39850,
	"./icons/alert-icon.svg": 91811,
	"./icons/app-icon.svg": 13842,
	"./icons/arrow-down.svg": 31759,
	"./icons/arrow-left.svg": 65648,
	"./icons/arrow-white.svg": 78210,
	"./icons/arrow_disabled_left.svg": 56507,
	"./icons/arrow_disabled_left_white.svg": 25061,
	"./icons/arrow_disabled_right.svg": 92862,
	"./icons/arrow_enabled_left.svg": 12636,
	"./icons/arrow_enabled_right.svg": 24259,
	"./icons/assignment-ind.svg": 53260,
	"./icons/badge2025.svg": 99753,
	"./icons/bank-icon.svg": 7709,
	"./icons/beta-menu.svg": 41687,
	"./icons/beta.svg": 65873,
	"./icons/better-v.svg": 75308,
	"./icons/blacktrash.svg": 19910,
	"./icons/blue-star.png": 83524,
	"./icons/broken-link-icon.svg": 87937,
	"./icons/butterfly.svg": 19480,
	"./icons/cash.svg": 52442,
	"./icons/challenge-action.svg": 36101,
	"./icons/chat_icon_dark_green.svg": 2678,
	"./icons/chat_icon_secondary.svg": 57156,
	"./icons/chat_icon_small.svg": 50371,
	"./icons/chat_icon_small_teriatry.svg": 9808,
	"./icons/chat_icon_small_white.svg": 85437,
	"./icons/chat_icon_teriatry.svg": 90280,
	"./icons/chat_icon_teriatry_white.svg": 79474,
	"./icons/check-green-icon.svg": 40251,
	"./icons/check-light-blue.svg": 50867,
	"./icons/check-list.svg": 95714,
	"./icons/check_mark.svg": 15367,
	"./icons/checkmark-blue-little.svg": 73768,
	"./icons/close-fat.svg": 37823,
	"./icons/close-thin.svg": 6207,
	"./icons/close-white.svg": 33025,
	"./icons/close.svg": 35837,
	"./icons/clover-check-mark.svg": 71691,
	"./icons/comment.svg": 29886,
	"./icons/credit-card-icon-disabled.svg": 67208,
	"./icons/credit-card-icon.svg": 49415,
	"./icons/credit-card-outline.svg": 88822,
	"./icons/credit-card.svg": 48531,
	"./icons/credit_card_24dp.svg": 5294,
	"./icons/credit_card_24dp_gray.svg": 15444,
	"./icons/discount-icon.svg": 22360,
	"./icons/dome-check-mark.svg": 67953,
	"./icons/edit-prediction.svg": 22071,
	"./icons/edits-exclude.svg": 45563,
	"./icons/edits-is-savings.svg": 32013,
	"./icons/edits-move.svg": 61404,
	"./icons/edits-not-savings.svg": 26136,
	"./icons/edits-sub-category.svg": 2200,
	"./icons/edits-trash.svg": 60711,
	"./icons/event.svg": 67449,
	"./icons/exclamation-mark-green.svg": 73322,
	"./icons/exclamation-mark-pink.svg": 94973,
	"./icons/exclamation-mark.svg": 80288,
	"./icons/exclemation-mark-blue.svg": 36221,
	"./icons/exclemation-mark-coral.svg": 21504,
	"./icons/exclemation-mark-gray.svg": 31264,
	"./icons/exclemation-mark-red.svg": 76374,
	"./icons/exclemation-mark-yellow.svg": 38957,
	"./icons/expand-arrow-down-medium-dark-green.svg": 98163,
	"./icons/expand-arrow-down-medium-disabled.svg": 48877,
	"./icons/expand-arrow-down-medium.svg": 92152,
	"./icons/expand-arrow-down-small-disabled.svg": 62187,
	"./icons/expand-arrow-down-small.svg": 44738,
	"./icons/filter_active.svg": 50530,
	"./icons/flag-grey.svg": 14871,
	"./icons/flag.svg": 41113,
	"./icons/gift.svg": 66081,
	"./icons/graph-bars.svg": 55656,
	"./icons/graph-line.svg": 96104,
	"./icons/gray-pencil.svg": 78272,
	"./icons/green-gift.svg": 6307,
	"./icons/green-light-bulb.svg": 95321,
	"./icons/green-star.png": 67879,
	"./icons/group-5.svg": 94250,
	"./icons/hands_raised.png": 56452,
	"./icons/heart-icon.svg": 56233,
	"./icons/heart.svg": 49733,
	"./icons/ic-close.svg": 65112,
	"./icons/icon-check-blue.svg": 51572,
	"./icons/icon-lock-gray.svg": 24488,
	"./icons/icon_add.svg": 85808,
	"./icons/icon_add_member.svg": 70681,
	"./icons/icon_edit.svg": 50919,
	"./icons/icon_left_arrow.svg": 17702,
	"./icons/icon_supermarket.svg": 57320,
	"./icons/info-icon-blue.svg": 3708,
	"./icons/info-icon-grey.svg": 5801,
	"./icons/intercom_empty.svg": 37712,
	"./icons/intercom_empty_invert.svg": 28627,
	"./icons/intercom_unread.svg": 27608,
	"./icons/intercom_unread_invert.svg": 85947,
	"./icons/left-blue-arrow.svg": 63777,
	"./icons/left-triangle.svg": 96573,
	"./icons/light-three-dots.svg": 64347,
	"./icons/location-marker.svg": 16885,
	"./icons/lock-blue.svg": 72595,
	"./icons/lock-grey.svg": 67926,
	"./icons/lock-outline.svg": 82643,
	"./icons/menu-white.svg": 77374,
	"./icons/menu.svg": 72434,
	"./icons/missing-card.svg": 59152,
	"./icons/modal-close-blue.svg": 3150,
	"./icons/modal-close-mustard.svg": 36788,
	"./icons/mode-edit.svg": 83559,
	"./icons/mortgages-flower.svg": 51416,
	"./icons/next-month-triangle.svg": 84618,
	"./icons/notice-gray.svg": 25741,
	"./icons/notice-green.png": 75827,
	"./icons/orange-x.svg": 70462,
	"./icons/pending.svg": 87352,
	"./icons/phone-vector.svg": 24707,
	"./icons/pink-flower.svg": 82217,
	"./icons/present.svg": 8368,
	"./icons/previous-month-triangle.svg": 59586,
	"./icons/profile/secondary-4.svg": 9622,
	"./icons/question-mark-icon.svg": 24003,
	"./icons/rami-levi-new-stamp.svg": 90610,
	"./icons/red-gift.svg": 24835,
	"./icons/redtrash.svg": 45830,
	"./icons/remove.svg": 82315,
	"./icons/right-triangle.svg": 44840,
	"./icons/sad-smiley-blue.svg": 19100,
	"./icons/sad-smiley-grey.svg": 48073,
	"./icons/savings-not-fixed.svg": 47109,
	"./icons/savings-not-variable.svg": 15701,
	"./icons/search-grey.svg": 32665,
	"./icons/search-vector.svg": 60397,
	"./icons/search.svg": 64343,
	"./icons/small_check.svg": 78421,
	"./icons/smiling-smiley-blue.svg": 93277,
	"./icons/smiling-smiley-grey.svg": 21812,
	"./icons/split.svg": 58933,
	"./icons/star-check-mark.svg": 63406,
	"./icons/star-white.svg": 62495,
	"./icons/success-icon.svg": 24662,
	"./icons/temp_transaction_large.svg": 51600,
	"./icons/temp_transaction_small.svg": 93304,
	"./icons/three-dots.svg": 81462,
	"./icons/thumbs-down.svg": 76469,
	"./icons/thumbs-up.svg": 31066,
	"./icons/trash.svg": 36891,
	"./icons/unknown-error.png": 84202,
	"./icons/v-blue.svg": 97876,
	"./icons/v-outline-filled-pink.svg": 52036,
	"./icons/v-outline.svg": 31562,
	"./icons/v-white.svg": 90463,
	"./icons/verified.svg": 25523,
	"./icons/vertical-three-dots.svg": 73023,
	"./icons/video-icon-blue.svg": 18219,
	"./icons/wallet-vector.svg": 11876,
	"./icons/warning-icon.svg": 12517,
	"./icons/whatsapp-icon.svg": 11813,
	"./icons/white-pencil.svg": 68620,
	"./icons/white-trash.svg": 70871,
	"./icons/yellow-light.svg": 58228,
	"./icons/yellow-sun.svg": 68394,
	"./intercom_chat_icon.svg": 67448,
	"./intercom_chat_icon_primary.svg": 31635,
	"./introduction/emun.png": 20878,
	"./introduction/intro_image_new_smaller.png": 61303,
	"./investigation_vis.svg": 79267,
	"./invite-member-message.png": 39746,
	"./invite-member-top.png": 71414,
	"./invite-member.png": 28000,
	"./invite-member.svg": 28756,
	"./leumi_riseup_friends.svg": 2139,
	"./lock.svg": 76807,
	"./lock_done.svg": 1946,
	"./lock_green.png": 55669,
	"./lock_icon.svg": 32001,
	"./logo-horizontal-green.svg": 26770,
	"./logo-horizontal-white.svg": 13512,
	"./logo-vertical-yellow.svg": 7803,
	"./logo-vertical.svg": 55646,
	"./mid-month/confetti.svg": 5324,
	"./mid-month/left.svg": 45591,
	"./mid-month/month-sticker.svg": 73428,
	"./mid-month/mute.svg": 53007,
	"./mid-month/next-arrow-cool.svg": 78439,
	"./mid-month/real-price-hashtag.svg": 67327,
	"./mid-month/restart.svg": 39653,
	"./mid-month/right-blue.svg": 87211,
	"./mid-month/right.svg": 55506,
	"./mid-month/share-logo.svg": 6011,
	"./mid-month/star-green.svg": 56886,
	"./mid-month/star-red.svg": 73574,
	"./mid-month/supermarket/average-bottom-arrow.svg": 55903,
	"./mid-month/supermarket/average-top-arrow.svg": 43707,
	"./mid-month/supermarket/boxing-gloves.gif": 60935,
	"./mid-month/supermarket/eggs.gif": 95731,
	"./mid-month/supermarket/food-bowl.gif": 37922,
	"./mid-month/supermarket/guy-with-shopping-cart.gif": 63511,
	"./mid-month/supermarket/location-orange.svg": 22364,
	"./mid-month/supermarket/location-pink.svg": 55234,
	"./mid-month/supermarket/location-yellow.svg": 13214,
	"./mid-month/supermarket/next-story-page-arrow.svg": 62125,
	"./mid-month/supermarket/shopping-cart.gif": 60036,
	"./mid-month/supermarket/tomato.gif": 32723,
	"./mid-month/supermarket/trophy.gif": 20383,
	"./mid-month/testimonials.png": 73946,
	"./mid-month/unmute.svg": 36770,
	"./money-moon/money-moon-join-header.svg": 57804,
	"./mortgage-monthly.svg": 19600,
	"./mortgage-total.svg": 88825,
	"./no-mortgage.svg": 91130,
	"./no-overdraft.png": 86737,
	"./no-results-drawing.png": 4269,
	"./ntd/ntd-banner.png": 19736,
	"./ntd/ntd-new-popup.svg": 58811,
	"./ntd/ntd-popup.svg": 15110,
	"./obk-arrow.svg": 53736,
	"./onboarding-discount.png": 14119,
	"./open-link-button.svg": 57384,
	"./oval@3x.png": 52579,
	"./paybox-challenge/calculator-background.svg": 33463,
	"./paybox-challenge/paybox-no-recommendation.png": 37491,
	"./paybox-challenge/paybox-welcome.png": 40824,
	"./paybox-challenge/riseup_plus_paybox.svg": 66973,
	"./payment/payment.svg": 34059,
	"./pc-no-support-icon.svg": 15441,
	"./pencil.svg": 95653,
	"./pending-icon.svg": 80931,
	"./pink-flower-card.svg": 29565,
	"./pink-flower-drawing.svg": 43439,
	"./planner/planner-info.svg": 87392,
	"./planner/planner-intro.svg": 90954,
	"./planner/planner.svg": 5331,
	"./promotion-present.png": 93435,
	"./promotion-success.png": 91599,
	"./promotions/21-days/21-days-promo-header.png": 10308,
	"./promotions/21-days/21-days-promo-welcome-header.png": 26173,
	"./promotions/aleph/aleph-header.svg": 80994,
	"./promotions/alljobs/alljobs-2-mo-image.png": 50058,
	"./promotions/alljobs/alljobs-3-mo-image.png": 39357,
	"./promotions/alljobs/alljobs-welcome.png": 83957,
	"./promotions/ashmoret/ashmoret_header.svg": 49368,
	"./promotions/bat-yam/batyam-header.png": 46233,
	"./promotions/bat-yam/batyam-header.svg": 63231,
	"./promotions/discount/discont_welcome_header.png": 51568,
	"./promotions/discount/discount-header.svg": 53438,
	"./promotions/discount/discount-riseup.svg": 54617,
	"./promotions/discount/discount_welcome_header_new.png": 59316,
	"./promotions/friends/friends-header.png": 96174,
	"./promotions/friends/friends-welcome-header.png": 41059,
	"./promotions/generic-signup-header.png": 78565,
	"./promotions/generic-welcome-header.png": 19653,
	"./promotions/harel/harel-header.png": 14802,
	"./promotions/harel/harel-welcome-header.png": 35599,
	"./promotions/hayanshuf/hayanshuf-header.svg": 41742,
	"./promotions/hever/hever-header.png": 18926,
	"./promotions/hever/hever-welcome-header.png": 15459,
	"./promotions/isracard/isracard-header.svg": 23302,
	"./promotions/isracard/isracard-welcome-header.png": 11971,
	"./promotions/jerusalem/jerusalem-header.svg": 60710,
	"./promotions/limited-time-offer-banner.svg": 3229,
	"./promotions/moneymoon.svg": 93594,
	"./promotions/netafim/netafim_header.png": 13632,
	"./promotions/nevo/nevo_header.svg": 22758,
	"./promotions/new-credit/new-credit.jpg": 28772,
	"./promotions/new-credit/newcredit_header.svg": 11097,
	"./promotions/percentage-discount/ariel-welcome.png": 9116,
	"./promotions/percentage-discount/ariel.png": 51163,
	"./promotions/percentage-discount/trima-welcome.png": 24396,
	"./promotions/percentage-discount/trima.png": 59819,
	"./promotions/percentage-discount/yes-welcome.png": 11596,
	"./promotions/percentage-discount/yes.png": 80683,
	"./promotions/promo-popup-image.svg": 77609,
	"./promotions/promotion-expired.svg": 59670,
	"./promotions/tarya/tarya-header.svg": 57710,
	"./promotions/yahav/yahav-signup.png": 61637,
	"./push-notifications/bulletGreen.svg": 72857,
	"./push-notifications/moveToPush.svg": 18624,
	"./push-notifications/popup-image.svg": 26998,
	"./rainbow-pink-yellow-red.svg": 35396,
	"./rainbow.svg": 7972,
	"./red-eight-pointed-alert-flower.svg": 28714,
	"./regulations-arrow.svg": 51773,
	"./remove-disabled.svg": 24107,
	"./riseup-giftcard/purchase_done.svg": 17406,
	"./riseup-giftcard/upsell-asset.png": 8692,
	"./riseup_logo.svg": 29576,
	"./rolling-credit-vis.svg": 58048,
	"./round-header-background.svg": 77745,
	"./search-drawing.png": 37113,
	"./share-popup/download.svg": 82893,
	"./share-popup/expand_more.svg": 49447,
	"./share-popup/share.svg": 89214,
	"./share_black_icon.svg": 93585,
	"./share_white_icon.svg": 97563,
	"./snapping-fingers-drawing.png": 27776,
	"./story-backgrounds/blue-white.png": 3146,
	"./story-backgrounds/cashflowy.png": 69450,
	"./story-backgrounds/default.png": 38031,
	"./story-backgrounds/expensive-day.png": 32366,
	"./story-backgrounds/november.png": 96208,
	"./story-backgrounds/real-price-hashtag.svg": 46699,
	"./story-backgrounds/vacation.png": 58467,
	"./story-backgrounds/wedding.png": 10996,
	"./story-backgrounds/worldcup.png": 55474,
	"./story-backgrounds/worth-it.png": 93228,
	"./subdirectory-arrow-left@3x.png": 21928,
	"./subscription-cta/cta-no-promo.png": 51927,
	"./subscription-cta/promo-sub-cta.png": 28762,
	"./subscription/Star 11.svg": 3690,
	"./subscription/Teachers04 1.png": 34608,
	"./subscription/Union.svg": 53901,
	"./subscription/account-settings-header.svg": 22617,
	"./subscription/after-payment-header.svg": 83523,
	"./subscription/checkout_header.svg": 77012,
	"./subscription/credit-card-header.svg": 89900,
	"./subscription/diamond.svg": 74308,
	"./subscription/discount.svg": 50001,
	"./subscription/edit_icon.svg": 71028,
	"./subscription/flow.png": 27740,
	"./subscription/header.svg": 17383,
	"./subscription/hourglass_bottom.svg": 45552,
	"./subscription/itemV.svg": 44145,
	"./subscription/limited-promotion.png": 29568,
	"./subscription/money-back-guarantee-header.svg": 7829,
	"./subscription/oval-green.png": 72970,
	"./subscription/oval-mustard.png": 92177,
	"./subscription/personal-info.png": 80767,
	"./subscription/riseup-icon.png": 12904,
	"./subscription/subscribe_header.svg": 98856,
	"./subscription/subscription-discount-10nis.png": 62479,
	"./subscription/subscription-type-header.svg": 4718,
	"./subscription/success.png": 81731,
	"./subscription/sun.svg": 51314,
	"./subscription/thnaks_for_subscribing_header.svg": 5855,
	"./subscription/time-is-running-up.png": 7788,
	"./sun.svg": 96868,
	"./sun2.svg": 8830,
	"./sun3.svg": 52559,
	"./sun4.svg": 86672,
	"./super-discount/all-logos-new.png": 76601,
	"./super-discount/all-logos.png": 9743,
	"./super-discount/carrefour.png": 30211,
	"./super-discount/carrefour/card-logo.png": 19800,
	"./super-discount/carrefour/carrefour-logos.png": 34800,
	"./super-discount/carrefour/discount.svg": 76761,
	"./super-discount/cart.png": 52382,
	"./super-discount/groceries.png": 54703,
	"./super-discount/growth.svg": 36309,
	"./super-discount/hachisuk/hachishuk-half-price.svg": 27569,
	"./super-discount/hachisuk/hachishuk-single.svg": 56370,
	"./super-discount/hachisuk/hachishuk.png": 89093,
	"./super-discount/mode_heat.svg": 33162,
	"./super-discount/my-vouchers/page-header-shape.svg": 47270,
	"./super-discount/my-vouchers/shape-hachishuk.svg": 51083,
	"./super-discount/my-vouchers/shape-rami.svg": 44432,
	"./super-discount/my-vouchers/shape-victory.svg": 93581,
	"./super-discount/rami-logo.png": 15425,
	"./super-discount/rami/buy-with-riseup-badge.svg": 21600,
	"./super-discount/rami/card-logo.png": 27750,
	"./super-discount/rami/card-logo_old.png": 90836,
	"./super-discount/rami/discount-green.svg": 71355,
	"./super-discount/rami/discount.svg": 18490,
	"./super-discount/rami/just-a-few-clicks.svg": 2713,
	"./super-discount/rami/rami-logos.png": 86064,
	"./super-discount/rami/rami-signle-logo.png": 46150,
	"./super-discount/super1.png": 40310,
	"./super-discount/super2.png": 72077,
	"./super-discount/super3.png": 8836,
	"./super-discount/super4.png": 47291,
	"./super-discount/super5.png": 42098,
	"./super-discount/super6.png": 90281,
	"./super-discount/thumbsup.png": 44412,
	"./super-discount/victory/6-discount-green.svg": 46109,
	"./super-discount/victory/card-logo.png": 11263,
	"./super-discount/victory/card-logo_old.png": 92165,
	"./super-discount/victory/discount.svg": 93092,
	"./super-discount/victory/just-a-few-clicks.svg": 55310,
	"./super-discount/victory/victory-logos-new.png": 40509,
	"./super-discount/victory/victory-logos.png": 91040,
	"./super-discount/victory/victory-signle-logo.png": 89398,
	"./testpng.png": 56267,
	"./tracking-categories/car.png": 10677,
	"./tracking-categories/clothing.png": 55611,
	"./tracking-categories/donation.png": 90149,
	"./tracking-categories/food.png": 87331,
	"./tracking-categories/leisure.png": 6382,
	"./tracking-categories/other.png": 68889,
	"./tracking-categories/pets.png": 83629,
	"./tracking-categories/pharma.png": 75796,
	"./tracking-categories/public-transportation.png": 38145,
	"./tracking-categories/super.png": 11838,
	"./tracking-categories/tourism.png": 51340,
	"./tracking-categories/tracking-categories-no-selection.svg": 80636,
	"./trusted.png": 89080,
	"./two-years-upfront/special-two-years-shape.svg": 95202,
	"./two-years-upfront/success.png": 1326,
	"./unchecked-circle.svg": 89659,
	"./whatsapp-icon.svg": 85234,
	"./whatsapp-optin.jpg": 79251,
	"./whatsapp.svg": 46144,
	"./wine-and-dine/CX.png": 18052,
	"./wine-and-dine/cover-image@3x.png": 41839,
	"./wine-and-dine/financial_advice_faces@2x.png": 20218,
	"./wine-and-dine/money-question@3x.png": 87771,
	"./wine-and-dine/other-products-intorduction/full-image.png": 73487,
	"./wine-and-dine/other-products-intorduction/introduction.png": 28700,
	"./wine-and-dine/other-products-intorduction/one-month-free.svg": 1490,
	"./wine-and-dine/other-products-intorduction/organized-categories.png": 66798,
	"./wine-and-dine/other-products-intorduction/personalize-categories.png": 24859,
	"./wine-and-dine/other-products-intorduction/reducible-expenses.png": 28849,
	"./wine-and-dine/trial-explanation-star.svg": 6200
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 50290;